"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.inIframe = void 0;

/**
 * Is In a frame
 *
 * @returns (bool) true when in a iframe
 */
var inIframe = function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}; // is default


exports.inIframe = inIframe;
var _default = inIframe;
exports["default"] = _default;